/* eslint-disable comma-dangle */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-assign */
/* eslint-disable no-underscore-dangle */
import csTools, { external } from 'cornerstone-tools';

const cursors = csTools.import('tools/cursors');
const { magnifyCursor } = cursors;
const MOUSECLICKTYPE = 'mousedown';
const VARIABLE_SIZE = 50;
const VARIABLE_MAGNIFY = 0.5;
const BaseTool = csTools.importInternal('base/BaseTool');

const getNewContext = (canvas) => {
  const context = canvas.getContext('2d');
  context.setTransform(1, 0, 0, 1, 0, 0);

  return context;
};

const SIZE_STYLE = 'color:yellow;width:26px;background:black;border:.5px solid yellow;outline:none;border-radius:4px;margin:4px;padding:2px;';
const MAG_STYLE = 'color:yellow;width:26px;background:black;border:.5px dashed yellow;outline:none;border-radius:4px;margin:4px;padding:2px';
const BOX_STYLE = 'position: absolute; left: 20px; padding :5px;display:flex;top:20px;align-item:center;align-items:center';

const createBox = (parent, style, className) => {
  const element = document.createElement('div');
  element.className = className;
  element.setAttribute('style', style);
  parent.appendChild(element);
  return element;
};

const createButton = (parent, label, style, func) => {
  const element = document.createElement('button');
  element.innerHTML = label;
  element.setAttribute('style', style);
  parent.appendChild(element);

  ['mouseover'].forEach((evento) =>
    element.addEventListener(
      evento,
      (e) => {
        e.stopPropagation();
        e.target.style.backgroundColor = 'yellow';
        e.target.style.color = 'black';
      },
      false
    )
  );
  ['mouseout'].forEach((evento) =>
    element.addEventListener(
      evento,
      (e) => {
        e.stopPropagation();
        e.target.style.backgroundColor = 'black';
        e.target.style.color = 'yellow';
      },
      false
    )
  );

  ['mousedown', 'touchstart'].forEach((evento) =>
    element.addEventListener(
      evento,
      (e) => {
        e.stopPropagation();
        func();
      },
      false
    )
  );
};

const createLabel = (parent, label) => {
  const element = document.createElement('span');
  element.innerHTML = label;

  const labelStyle = 'color:yellow; width: 52px;text-align:center;align-items:center';
  element.setAttribute('style', labelStyle);
  parent.appendChild(element);
};

export default class MagnifyPlusTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'MagnifyPlus',
      supportedInteractionTypes: ['Mouse', 'Touch'],
      configuration: {
        magnifySize: 250,
        magnificationLevel: 4,
      },
      svgCursor: magnifyCursor,
    };

    super(props, defaultProps);

    this.zoomCanvas = undefined;
    this.zoomElement = undefined;
    this.elementClick = undefined;
    this.wrapperPos = undefined;

    // Mode Callbacks: (element, options)
    this.activeCallback = this._activeCallback.bind(this);
    this.enabledCallback = this._addMagnifyingGlass.bind(this);
    this.disabledCallback = this._destroyMagnificationCanvas.bind(this);

    // Touch
    this.postTouchStartCallback = this._addMagnifyingGlass.bind(this);
    this.touchDragCallback = this._updateMagnifyingGlass.bind(this);
    this.touchEndCallback = this._removeMagnifyingGlass.bind(this);
    this.touchDragEndCallback = this._removeMagnifyingGlass.bind(this);

    // // Mouse
    this.postMouseDownCallback = this._addMagnifyingGlass.bind(this);
    this.mouseDragCallback = this._updateMagnifyingGlass.bind(this);
    this.mouseUpCallback = this._removeMagnifyingGlass.bind(this);
    // On quick clicks, mouseUp does not fire, but this does
    this.mouseClickCallback = this._removeMagnifyingGlass.bind(this);
    // Misc
    this.newImageCallback = this._drawMagnificationTool.bind(this);
  }

  plusMagnification = () => {
    const magnification = this.configuration.magnificationLevel + VARIABLE_MAGNIFY;
    this.configuration.magnificationLevel = Math.min(magnification, 8);

    this._simulateMouseClick(this.elementClick);
  };

  minusMagnification = () => {
    const magnification = this.configuration.magnificationLevel - VARIABLE_MAGNIFY;
    this.configuration.magnificationLevel = Math.max(magnification, 1);

    this._simulateMouseClick(this.elementClick);
  };

  plusSize = () => {
    const size = this.configuration.magnifySize + VARIABLE_SIZE;
    this.configuration.magnifySize = Math.min(size, 800);

    this._simulateMouseClick(this.elementClick);
  };

  minusSize = () => {
    const size = this.configuration.magnifySize - VARIABLE_SIZE;
    this.configuration.magnifySize = Math.max(size, 100);

    this._simulateMouseClick(this.elementClick);
  };

  _activeCallback = (evt) => {
    this._createMagnificationCanvas(evt);
    this._simulateMouseClick(evt);
  };

  _addMagnifyingGlass(evt) {
    // Ignore until next event
    this._removeZoomElement();
    this._drawZoomedElement(evt);
    // On next frame
    window.requestAnimationFrame(() => this._drawMagnificationTool(evt));

    evt.preventDefault();
    evt.stopPropagation();
  }

  _updateMagnifyingGlass(evt) {
    this._drawMagnificationTool(evt);

    evt.preventDefault();
    evt.stopPropagation();
  }

  _removeMagnifyingGlass(evt) {
    const { element } = evt.detail;

    // element.querySelector('.magnifyPlusTool').style.display = 'block';
    this._removeZoomElement();
  }

  _drawMagnificationTool(evt) {
    const { element } = evt.detail;
    const wrapper = element.querySelector('.magnifyPlusTool');
    const magnifyCanvas = wrapper.querySelector('canvas');
    const sizeText = wrapper.querySelector('.sizeText');
    const magText = wrapper.querySelector('.magText');

    if (!wrapper) {
      this._createMagnificationCanvas(element);
    }

    if (this.zoomCanvas === undefined) return;

    // The 'not' magnifyTool class here is necessary because cornerstone places
    // No classes of it's own on the canvas we want to select
    const canvas = element.querySelector('canvas:not(.magnifyPlusTool)');
    const context = getNewContext(magnifyCanvas);

    // Calculate the on-canvas location of the mouse pointer / touch

    if (!evt.detail.currentPoints) {
      return;
    }

    const canvasLocation = external.cornerstone.pixelToCanvas(evt.detail.element, evt.detail.currentPoints.image);

    // Shrink magnifier to smallest canvas dimension if smaller than desired magnifier size
    const size = Math.min(this.configuration.magnifySize, canvas.width, canvas.height);
    const { magnificationLevel } = this.configuration;

    magnifyCanvas.width = size;
    magnifyCanvas.height = size;
    sizeText.innerHTML = `Size: ${this.configuration.magnifySize}`;
    sizeText.style.color = 'yellow';
    magText.innerHTML = `Magnification: ${this.configuration.magnificationLevel}`;
    magText.style.color = 'yellow';

    // Constrain drag movement to zoomed image boundaries
    canvasLocation.x = Math.max(canvasLocation.x, (0.5 * size) / magnificationLevel);
    canvasLocation.x = Math.min(canvasLocation.x, canvas.width - (0.5 * size) / magnificationLevel);
    canvasLocation.y = Math.max(canvasLocation.y, (0.5 * size) / magnificationLevel);
    canvasLocation.y = Math.min(canvasLocation.y, canvas.height - (0.5 * size) / magnificationLevel);

    const copyFrom = {
      x: canvasLocation.x * magnificationLevel - 0.5 * size,
      y: canvasLocation.y * magnificationLevel - 0.5 * size,
    };

    copyFrom.x = Math.max(copyFrom.x, 0);
    copyFrom.y = Math.max(copyFrom.y, 0);

    context.drawImage(this.zoomCanvas, copyFrom.x, copyFrom.y, size, size, 0, 0, size, size);

    // Place the magnification tool at the same location as the pointer
    const touchOffset = evt.detail.isTouchEvent ? 120 : 0;
    const pos = {
      top: Math.max(canvasLocation.y - 0.5 * size - touchOffset, 0),
      left: Math.max(canvasLocation.x - 0.5 * size, 0),
    };

    // Get full magnifier dimensions with borders
    const Box = wrapper.getBoundingClientRect();

    // Constrain magnifier to canvas boundaries
    pos.top = Math.min(pos.top, canvas.height - Box.height);
    pos.left = Math.min(pos.left, canvas.width - Box.width);

    wrapper.style.top = `${pos.top}px`;
    wrapper.style.left = `${pos.left}px`;
    wrapper.style.display = 'block';
    const sizeBox = element.querySelector('.sizeBox');
    const magBox = element.querySelector('.magBox');
    sizeBox.style.display = 'flex';
    magBox.style.display = 'flex';
  }

  _drawZoomedElement(evt) {
    const { element } = evt.detail;
    let { enabledElement } = evt.detail;

    if (enabledElement === undefined) {
      enabledElement = external.cornerstone.getEnabledElement(element);
    }

    const { magnificationLevel } = this.configuration;
    const origCanvas = enabledElement.canvas;
    const { image } = enabledElement;

    // Create a new cornerstone enabledElement
    if (!this.zoomElement) {
      this.zoomElement = document.createElement('div');
      this.zoomElement.width = origCanvas.width * magnificationLevel;
      this.zoomElement.height = origCanvas.height * magnificationLevel;
      external.cornerstone.enable(this.zoomElement, enabledElement.options);
    }

    const zoomEnabledElement = external.cornerstone.getEnabledElement(this.zoomElement);
    const viewport = external.cornerstone.getViewport(enabledElement.element);

    this.zoomCanvas = zoomEnabledElement.canvas;
    this.zoomCanvas.width = origCanvas.width * magnificationLevel;
    this.zoomCanvas.height = origCanvas.height * magnificationLevel;
    this.zoomElement.classList.add('zoomElement');

    zoomEnabledElement.viewport = { ...viewport };

    // Update it's viewport to render at desired magnification level
    viewport.scale *= magnificationLevel;
    external.cornerstone.displayImage(this.zoomElement, image);
    external.cornerstone.setViewport(this.zoomElement, viewport);
    // To do enable annotation tools for zoomElement
  }

  _removeZoomElement() {
    if (this.zoomElement !== undefined) {
      external.cornerstone.disable(this.zoomElement);
      this.zoomElement = undefined;
      this.zoomCanvas = undefined;
    }
  }

  _createMagnificationCanvas(element) {
    if (element.querySelector('.magnifyPlusTool') === null) {
      const magnifyWrapper = document.createElement('div');

      const sizeText = document.createElement('p');
      sizeText.innerHTML = `Size: ${this.configuration.magnifySize}`;
      sizeText.className = 'sizeText';
      sizeText.style.textShadow = '1px 1px black';

      const magText = document.createElement('p');
      magText.innerHTML = `Magnification: ${this.configuration.magnificationLevel}`;
      magText.className = 'magText';
      magText.style.textShadow = '1px 1px black';

      const sizeBox = createBox(element, `${BOX_STYLE};top:200px`, 'sizeBox');
      const magBox = createBox(element, `${BOX_STYLE};top:252px`, 'magBox');

      createButton(sizeBox, '+', SIZE_STYLE, this.plusSize);
      createLabel(sizeBox, 'Size');
      createButton(sizeBox, '-', SIZE_STYLE, this.minusSize);

      createButton(magBox, '+', MAG_STYLE, this.plusMagnification);
      createLabel(magBox, 'Magni.');
      createButton(magBox, '-', MAG_STYLE, this.minusMagnification);

      magnifyWrapper.classList.add('magnifyPlusTool');
      magnifyWrapper.style.position = 'absolute';
      magnifyWrapper.style.display = 'block';

      const magnifyCanvas = document.createElement('canvas');
      magnifyCanvas.style.position = 'relative';
      magnifyCanvas.style.display = 'block';

      magnifyCanvas.width = this.configuration.magnifySize;
      magnifyCanvas.height = this.configuration.magnifySize;
      magnifyCanvas.style.borderRadius = '50%';
      magnifyCanvas.style.boxShadow = '2px 2px 10px black';
      magnifyCanvas.style.border = '2px solid yellow';

      magnifyWrapper.appendChild(magnifyCanvas);
      magnifyWrapper.appendChild(sizeText);
      magnifyWrapper.appendChild(magText);

      element.appendChild(magnifyWrapper);

      magnifyCanvas.addEventListener('mouseup', (e) => {
        this.wrapperPos = { x: e.clientX, y: e.clientY };
      });

      magnifyCanvas.addEventListener('touchend', (e) => {
        this.wrapperPos = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      });

      magnifyCanvas.addEventListener('wheel', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.deltaY > 0) {
          this.plusMagnification();
        } else {
          this.minusMagnification();
        }
      });
    }
    this.elementClick = element;
  }

  _destroyMagnificationCanvas(element) {
    const magnifyWrapper = element.querySelector('.magnifyPlusTool');

    if (magnifyWrapper) {
      magnifyWrapper.style.display = 'none';
      // element.removeChild(magnifyWrapper);
    }
    const sizeBox = element.querySelector('.sizeBox');
    const magBox = element.querySelector('.magBox');

    if (sizeBox) {
      sizeBox.style.display = 'none';
    }
    if (magBox) {
      magBox.style.display = 'none';
    }
  }

  _simulateMouseClick(evt) {
    const evtRect = evt.getBoundingClientRect();

    evt.dispatchEvent(
      new MouseEvent(MOUSECLICKTYPE, {
        clientX: this.wrapperPos ? this.wrapperPos.x : evtRect.x + evtRect.width / 2,
        clientY: this.wrapperPos ? this.wrapperPos.y : evtRect.y + evtRect.height / 2,
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      })
    );
  }
}
